import { render, staticRenderFns } from "./CommonProblem.vue?vue&type=template&id=0904ea6d&scoped=true&"
import script from "./CommonProblem.vue?vue&type=script&lang=js&"
export * from "./CommonProblem.vue?vue&type=script&lang=js&"
import style0 from "./CommonProblem.vue?vue&type=style&index=0&id=0904ea6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0904ea6d",
  null
  
)

export default component.exports